import React, { Component } from "react";
import { Modal, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import CollectionForm from "./components/CollectionForm";
import { collectionFormModalTriggerSources } from "../../constants";
import { closeCollectionFormModal, openAddToCollectionModal } from "../../actions/collectionActions";
import "./index.css";

class CollectionFormModal extends Component {
  constructor(props) {
    super(props);
    this.goBackToCollectionSelection = this.goBackToCollectionSelection.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  goBackToCollectionSelection() {
    this.props.actions.closeCollectionFormModal();
    this.props.actions.openAddToCollectionModal(this.props.selectedPost);
  }

  submitForm() {
    this.props.actions.submitForm();
  }

  render() {
    return (
      <Modal
        className="new-collection-modal"
        size={"tiny"}
        trigger={this.props.trigger}
        open
        onClose={this.props.actions.closeCollectionFormModal}
      >
        {this.props.triggerSource === collectionFormModalTriggerSources.ADD_TO_COLLECTION_MODAL && (
          <Icon name="arrow left" size="large" className="back-btn" onClick={this.goBackToCollectionSelection} />
        )}
        <CollectionForm onSubmit={this.submitForm} />
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    triggerSource: state.ui.collectionFormModal.source,
    selectedPost: state.ui.addToCollectionModal.postId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      closeCollectionFormModal: () => dispatch(closeCollectionFormModal()),
      openAddToCollectionModal: postId => dispatch(openAddToCollectionModal(postId)),
      submitForm: postId => dispatch(submit("collectionModalForm")),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionFormModal);



// WEBPACK FOOTER //
// ./src/components/CollectionFormModal/index.js